export enum OrderPriceTypeEnum {
    Undefined = 48,
    Market,
    Limited,
    StopLoss,
    StopLimited,
    MarketWithLeftOverAsLimit
}